<template>
  <div class="silent-hours-container">
    <div class="silent-hours-input-group">
      <label class="silent-hours-sub-label">{{ startLabel }}</label>
      <div class="silent-hours-time-row">
        <select
          v-model="startHourModel"
          :disabled="inputsDisabled"
          class="silent-hours-time-select"
        >
          <option :value="null">--</option>
          <option v-for="hour in hours" :key="hour" :value="hour">
            {{ hour }}
          </option>
        </select>
        <span>:</span>
        <select
          v-model="startMinuteModel"
          :disabled="inputsDisabled"
          class="silent-hours-time-select"
        >
          <option :value="null">--</option>
          <option v-for="minute in minutes" :key="minute" :value="minute">
            {{ minute }}
          </option>
        </select>
      </div>
    </div>

    <div class="silent-hours-input-group">
      <label class="silent-hours-sub-label">{{ endLabel }}</label>
      <div class="silent-hours-time-row">
        <select v-model="endHourModel" :disabled="inputsDisabled" class="silent-hours-time-select">
          <option :value="null">--</option>
          <option v-for="hour in hours" :key="`end-${hour}`" :value="hour">
            {{ hour }}
          </option>
        </select>
        <span>:</span>
        <select
          v-model="endMinuteModel"
          :disabled="inputsDisabled"
          class="silent-hours-time-select"
        >
          <option :value="null">--</option>
          <option v-for="minute in minutes" :key="`end-${minute}`" :value="minute">
            {{ minute }}
          </option>
        </select>
      </div>
    </div>

    <div class="silent-hours-buttons mobile-stretch-btn-group">
      <button
        type="button"
        :disabled="clearDisabled"
        class="btn-sm btn-secondary silent-hours-action-btn"
        @click="$emit('clear')"
      >
        {{ clearText }}
      </button>
      <button
        type="button"
        :disabled="saveDisabled"
        class="btn-sm btn-primary silent-hours-action-btn"
        @click="$emit('save')"
      >
        {{ saving ? savingText : saveText }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  startHour: { type: [String, Number, null], default: null },
  startMinute: { type: [String, Number, null], default: null },
  endHour: { type: [String, Number, null], default: null },
  endMinute: { type: [String, Number, null], default: null },
  inputsDisabled: { type: Boolean, default: false },
  clearDisabled: { type: Boolean, default: false },
  saveDisabled: { type: Boolean, default: false },
  saving: { type: Boolean, default: false },
  startLabel: { type: String, required: true },
  endLabel: { type: String, required: true },
  clearText: { type: String, required: true },
  saveText: { type: String, required: true },
  savingText: { type: String, required: true },
})

const emit = defineEmits([
  'update:startHour',
  'update:startMinute',
  'update:endHour',
  'update:endMinute',
  'clear',
  'save',
])

const hours = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'))
const minutes = ['00', '15', '30', '45']

const startHourModel = computed({
  get: () => props.startHour,
  set: value => emit('update:startHour', value),
})

const startMinuteModel = computed({
  get: () => props.startMinute,
  set: value => emit('update:startMinute', value),
})

const endHourModel = computed({
  get: () => props.endHour,
  set: value => emit('update:endHour', value),
})

const endMinuteModel = computed({
  get: () => props.endMinute,
  set: value => emit('update:endMinute', value),
})
</script>

<style scoped>
.silent-hours-sub-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  display: block;
}

.silent-hours-time-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.silent-hours-time-select {
  flex: 1;
  min-width: 60px;
}
</style>
